export var AdEventKey;
(function (AdEventKey) {
    AdEventKey["AD_METADATA"] = "AD_METADATA";
    AdEventKey["AD_BREAK_STARTED"] = "AD_BREAK_STARTED";
    AdEventKey["AD_BREAK_ENDED"] = "AD_BREAK_ENDED";
    AdEventKey["AD_LOADED"] = "AD_LOADED";
    AdEventKey["AD_STARTED"] = "AD_STARTED";
    AdEventKey["AD_PAUSED"] = "AD_PAUSED";
    AdEventKey["AD_POSITION_CHANGED"] = "AD_POSITION_CHANGED";
    AdEventKey["AD_FIRST_QUARTILE"] = "AD_FIRST_QUARTILE";
    AdEventKey["AD_MIDPOINT"] = "AD_MIDPOINT";
    AdEventKey["AD_THIRD_QUARTILE"] = "AD_THIRD_QUARTILE";
    AdEventKey["AD_ENDED"] = "AD_ENDED";
    AdEventKey["AD_SKIPPED"] = "AD_SKIPPED";
    AdEventKey["AD_ERROR"] = "AD_ERROR";
    AdEventKey["AD_RESUMED"] = "AD_RESUMED";
    AdEventKey["CONTENT_PAUSE_REQUESTED"] = "CONTENT_PAUSE_REQUESTED";
    AdEventKey["CONTENT_RESUME_REQUESTED"] = "CONTENT_RESUME_REQUESTED";
    AdEventKey["PAUSE_AD_PARSED"] = "PAUSE_AD_PARSED";
    AdEventKey["AD_BREAK_SKIP_AVAILABLE"] = "AD_BREAK_SKIP_AVAILABLE";
    AdEventKey["AD_BREAK_SKIP_UNAVAILABLE"] = "AD_BREAK_SKIP_UNAVAILABLE";
    AdEventKey["PAUSE_AD_STREAM_PAUSED"] = "PAUSE_AD_STREAM_PAUSED";
    AdEventKey["PAUSE_AD_REQUESTED"] = "PAUSE_AD_REQUESTED";
})(AdEventKey || (AdEventKey = {}));
